// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const lombre: PokeData = {
  "id": 271,
  "name": "lombre",
  "height": 12,
  "weight": 325,
  "base_experience": 119,
  "types": [
    PokeType.WATER,
    PokeType.GRASS
  ],
  "api_moves": [
    "growl",
    "mist",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "absorb",
    "mega-drain",
    "leech-seed",
    "bubble",
    "fury-swipes",
    "thief",
    "flail",
    "giga-drain",
    "rain-dance",
    "fake-out",
    "uproar",
    "nature-power",
    "knock-off",
    "teeter-dance",
    "astonish",
    "water-sport",
    "energy-ball",
    "zen-headbutt"
  ],
  "moves": [
    "growl",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "rain-dance",
    "energy-ball",
    "zen-headbutt",
    "aqua-jet",
    "flower-rush",
    "aromatherapy",
    "water-spout",
    "liquidation",
    "branch-poke"
  ],
  "evolution_chain": {
    "id": 136,
    "item": null,
    "species": [
      {
        "name": "lotad",
        "order": 295,
        "types": [
          PokeType.WATER,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lombre",
        "order": 296,
        "types": [
          PokeType.WATER,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 270,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 14,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "ludicolo",
        "order": 297,
        "types": [
          PokeType.WATER,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 271,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "water-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 60,
    "speed": 50,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
